export default {
	mobileOSList: ['ios', 'android os', 'windows mobile']
}
